import { useRef, useEffect } from 'react';

export const useIntervalTimer = (cb, time) => {
  const cbRef = useRef(null);
  useEffect(() => {
    // This keeps a reference to the original function in memory for calls back in the timer
    cbRef.current = cb;
  });
  useEffect(() => {
    const interval = setInterval(() => cbRef.current(), time);
    return () => clearInterval(interval);
  }, [time]);
};
